import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from "@angular/material/bottom-sheet";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, MenuController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { StoreRepositoryService } from "src/app/pages/store/store-repository.service";
import { SocialService } from "src/app/services/social.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperModule } from "swiper/angular";
import { FilterYoursToPlay } from "../../../../pipe/yours-to-play/yoursToPlay";
import { CountDownTimerComponent } from "../../../count-down-timer/count-down-timer.component";
import { InProgressAnimationComponent } from "../../../in-progress-animation/in-progress-animation.component";
import { CommunitySubtabsComponent } from "../../community-subtabs/community-subtabs.component";

@Component({
  selector: "app-fortune-discover",
  templateUrl: "./fortune-discover.component.html",
  styleUrls: ["./fortune-discover.component.scss"],
  standalone: true,
  imports: [
    NgIf,
    SwiperModule,
    NgFor,
    IonicModule,
    CountDownTimerComponent,
    InProgressAnimationComponent,
    AsyncPipe,
    FilterYoursToPlay,
    TranslatePipe,
  ],
})
export class FortuneDiscoverComponent implements OnInit {
  socialFortuneDiscoverPromises$ = new BehaviorSubject(null);
  socalFortueDiscoveryFriendsPromises$ = new BehaviorSubject(null);
  selectedLanguage: string;
  public preferredCurrency: string;
  public currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  public jackpotData: string;

  constructor(
    private sheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data,
    private menu: MenuController,
    public translate: TranslateService,
    private socialService: SocialService,
    private storeService: StoreRepositoryService,
    private router: Router,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }
  loaded: boolean;

  public big_discoverSliderOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    slideToClickedSlide: true,
  };
  public discoverSliderOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    slideToClickedSlide: true,
  };
  close() {
    this.sheet.dismiss();
    this.menu.open("inboxMenu").catch((err) => {
      return err;
    });
  }
  ngOnInit() {
    this.jackpotData = "-1";
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.authService.userDetails$.subscribe((user) => {
      this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
      this.authService.getCurrencyList$.subscribe((data: Data) => {
        const CurrencyDetails = data?.details?.find((item) => item?.currency_code === this.preferredCurrency);
        this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
      });
    });
    this.loaded = true;
    this.socialService.socialFortuneDiscoverPromises().then((d) => {
      this.socialFortuneDiscoverPromises$.next(d);
    }).catch((error) => {
      return error;
    });
    this.socialService.socalFortueDiscoveryfriendsPromises().then((d) => {
      this.socalFortueDiscoveryFriendsPromises$.next(d);
    }).catch((error) => {
      return error;
    });

    // the jackpot values of each element in the data array. It then updates the data array to only include items with valid jackpot values which has Highest jackpot value.
    this.socialFortuneDiscoverPromises$?.pipe(filter((f) => f != undefined)).subscribe((data) => {
      try {
        const jackpotValues = [];
        for (const key of Object.keys(data)) {
          if (key === "try") {
            data[key].forEach((element) => {
              const jackpotValue = parseFloat(element["lotteryData"]["jackpot_value"].replace(/[^\d.-]/g, ""));
              if (isNaN(jackpotValue)) {
                throw new Error("Invalid jackpot value:" + element["lotteryData"]["jackpot_value"]);
                return; // Skip this object if the jackpot value cannot be converted to float
              }
              jackpotValues.push({ object: element, value: jackpotValue });
            });

            jackpotValues.sort((a, b) => b.value - a.value);
            const sortedObjects = jackpotValues.map((item) => item?.object);
            const validJackpotArrays = sortedObjects?.filter(
              (obj) => obj["lotteryData"]["jackpot_value"] != this.jackpotData
            );
            data[key] = validJackpotArrays;
          }
        }
      } catch (error) {
        throw new Error("Error occurred while processing data:" + error);
      }
    });
    this.socalFortueDiscoveryFriendsPromises$?.pipe(filter((f) => f != undefined)).subscribe((data) => {
      for (const key of Object.keys(data)) {
        const validJackpotArrays = [];
        const invalidJackpotArrays = [];
        for (const obj of data[key]) {
          if (obj["friends"]["jackpot_value"] === this.jackpotData) {
            invalidJackpotArrays.push(obj);
          } else {
            validJackpotArrays.push(obj);
          }
        }
        data[key] = validJackpotArrays;
      }
    });
  }
  showJackpotDetails(name) {
    this.storeService?.storePageData$?.subscribe(
      (res) => {
        if (!res) return;
        // if (window.location.href.search("home") > -1) {
        this.storeService?.selectedProduct$.next(res?.find((x) => x?.real_name?.toLowerCase() === name?.toLowerCase()));
        this.router.navigate([`/store/products/${name}`]);
        this.sheet.dismiss();
        // }
      },
      (err) => {
        return err;
      }
    );
  }

  private openCommnuityTab() {
    this.sheet.open(CommunitySubtabsComponent, {
      panelClass: "fortune-mat-bottomsheet",
      backdropClass: "FortuneDiscover-backdrop",
      hasBackdrop: true,
      data: { currentTab: 3 },
    });
  }
}
